export default __webpack_public_path__ + "static/firstHealth-d0b4aa46070837c9886b57489d9d33bf.svg";